'use client'

import React, { useEffect } from 'react'

import useCartStore from '@/app/book/stores/useCartStore'
import useCouponStore from '@/app/book/stores/useCouponStore'

/**
 * Syncs booking-flow params from the URL into their stores on landing.
 * Marketing attribution (store capture + backend touch) lives in
 * `AttributionCapture`, which runs inside the providers.
 */
const SearchParamSync: React.FC = () => {
  const setCoupon = useCouponStore((store) => store.setCoupon)
  const [setClickId, currentClickId] = useCartStore((state) => [state.setClickId, state.clickId])

  useEffect(() => {
    if (typeof window === 'undefined') return

    const params = new URLSearchParams(window.location.search)
    const clickId = params.get('click_id')
    const coupon = params.get('coupon')

    if (clickId && currentClickId !== clickId) {
      setClickId(clickId)
    }

    if (coupon) {
      setCoupon(coupon)
    }
  }, [currentClickId, setClickId, setCoupon])

  return null
}

export default SearchParamSync
